import { Field, FormConfig } from 'common.types'
import React from 'react'
import { FaEdit } from 'react-icons/fa'

import { useTranslation } from 'react-i18next'
import './ReviewSubmission.scss'

type ReviewSubmissionProps = {
  formState: {
    [key: string]: any
  }
  fieldConfig: Field[]
  i18nName: string
  onClickEdit?: (step: number, inputName: string) => void
}
export const ReviewSubmission: React.FC<ReviewSubmissionProps> = ({
  formState,
  fieldConfig,
  i18nName,
  onClickEdit,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: i18nName })
  const { t: componentT } = useTranslation(undefined, {
    keyPrefix: `reviewSubmission`,
  })
  const processValue = (fieldItem: Field, value: any) => {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No'
    }
    if (fieldItem.type === 'select' && !fieldItem.selectLabelsFromOptions) {
      return t(`fields.${fieldItem.name}.options.${value}`)
    }
    return value
  }
  return (
    <div className="review-submission">
      <h3 className="review-submission__header">{componentT('title')}</h3>

      <table className="review-submission__table">
        <thead>
          <tr>
            <th className="review-submission__table__header">
              {componentT('label')}
            </th>
            <th className="review-submission__table__header">
              {componentT('value')}
            </th>
          </tr>
        </thead>
        <tbody>
          {fieldConfig
            .filter((item) => {
              return (
                ![
                  'lang',
                  'step',
                  'captchaValidated',
                  'dataConsent',
                  'agreement',
                  'signature',
                ].includes(item.name) &&
                item.type !== 'html' &&
                formState[item.name]
              )
            })
            .map((item, index) => (
              <tr key={index}>
                <td className="review-submission__table__cell">
                  {t(`fields.${item.name}.label`).replace(
                    /<\/?[^>]+(>|$)/g,
                    '',
                  )}
                </td>
                <td className="review-submission__table__cell">
                  <div className="review-submission__table__cell__inner">
                    {processValue(item, formState[item.name])}
                    {onClickEdit ? (
                      <button
                        aria-label={componentT('edit')}
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          onClickEdit(item.step, item.name)
                        }}
                        className="review-submission__table__cell__edit"
                      >
                        <FaEdit
                          className="review-submission__table__cell__edit__icon"
                          size={22}
                        />
                      </button>
                    ) : null}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}
